import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-info-backoffice',
  templateUrl: './aggiungi-info-backoffice.component.html',
  styleUrl: './aggiungi-info-backoffice.component.css'
})
export class AggiungiInfoBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  formInfo!: FormGroup;

  info_items: number[] = [0]  

  ngOnInit(): void {

    this.formInfo = new FormGroup({})

    this.info_items.map((contenuto, index) => {
      this.formInfo.addControl('titolo_' + index, new FormControl(null, Validators.required))
      this.formInfo.addControl('descrizione_' + index, new FormControl(null))
    })

  }

  onAddItem() {

    this.info_items.push(0)

    this.info_items.map((contenuto, index) => {
      this.formInfo.addControl('titolo_' + index, new FormControl(null, Validators.required))
      this.formInfo.addControl('descrizione_' + index, new FormControl(null))
    })

  }

  onRemoveItem(index: number) {
    this.info_items.splice(index, 1);

    this.formInfo.removeControl('titolo_' + index)
    this.formInfo.removeControl('descrizione_' + index)
  }

  onSubmit() {

    let info: any = { items: [] }

    this.info_items.map((number, index) => {

      const titolo = this.formInfo.get('titolo_' + index)?.value || '';
      const descrizione = this.formInfo.get('descrizione_' + index)?.value || '';

      info.items.push({titolo: titolo, descrizione: descrizione});

    })

    this.apiService.addInfo(info).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.setInfos();
        this.apiService.message('success', 'Successo', 'La info è stata aggiunta con successo!');
        this.router.navigate(['/backoffice/info'])
      }
    })

  }


}
